import { render, staticRenderFns } from "./HouseholdInquiryInside.vue?vue&type=template&id=c28d4742&"
import script from "./HouseholdInquiryInside.vue?vue&type=script&lang=js&"
export * from "./HouseholdInquiryInside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports